"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useAuth = exports.AuthProvider = exports.AuthContext = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./AuthProvider.less");
var _utils = require("../../utils");
var _ = require("./..");
var _redirectService = require("./redirectService");
var _useIdentity2 = require("./useIdentity");
var _useLogout2 = require("./useLogout");
var _useAuthenticated2 = require("./useAuthenticated");
var _useIdlePing2 = require("./useIdlePing");
var _utils2 = require("./utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) { if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } } return n.default = e, t && t.set(e, n), n; }
var redirectToSignIn = _redirectService.redirectService.redirectToSignIn;
var AuthContext = /*#__PURE__*/_react.default.createContext({
  isAuthenticated: false,
  user: undefined,
  loadingUser: true,
  logout: function logout() {},
  performIdlePing: function performIdlePing() {},
  refetchUser: function refetchUser() {},
  wipeIdentity: function wipeIdentity() {}
});
exports.AuthContext = AuthContext;
var useAuth = function useAuth() {
  return (0, _react.useContext)(AuthContext);
};
exports.useAuth = useAuth;
var guardRenderingApp = function guardRenderingApp(_ref) {
  var loadingInitial = _ref.loadingInitial,
    ignorePaths = _ref.ignorePaths,
    identity = _ref.identity,
    isLoggedOut = _ref.isLoggedOut,
    children = _ref.children;
  if (loadingInitial) {
    return /*#__PURE__*/_react.default.createElement(_.SpinGlobal, null);
  }
  if ((0, _utils2.canPathIgnoreAuth)(window.location.pathname, ignorePaths)) {
    // If current path doesn't require an authenticaed user, it is safe to render rest of app
    // without confirming that user exists
    return children;
  }
  if (isLoggedOut) {
    // Redirecting to our Auth0 domain’s logout endpoint is necessary to clear
    // the Auth0 session which persists when using Universal Login.
    // @BrandLibel
    var auth0LogoutUrl = "https://".concat(process.env.REACT_APP_AUTH0_DOMAIN, "/v2/logout");
    window.location.href = auth0LogoutUrl;
    return null;
  }
  if (!identity) {
    if (_utils.isAppOnEnv) {
      redirectToSignIn(window.location.pathname);
      return null;
    } else {
      // @TODO: do any developers actually use the stub-server?
      return /*#__PURE__*/_react.default.createElement("div", null, "Turn on stub-server before starting the app (unauthorized)");
    }
  }
  // If identity is defined, then user is authenticated and rest of app (children) can be rendered
  return children;
};
var AuthProvider = function AuthProvider(_ref2) {
  var children = _ref2.children,
    ignorePaths = _ref2.ignorePaths;
  var _useIdentity = (0, _useIdentity2.useIdentity)(),
    loadingUser = _useIdentity.loadingUser,
    identity = _useIdentity.identity,
    wipeIdentity = _useIdentity.wipeIdentity,
    logout = _useIdentity.logout,
    isLoggedOut = _useIdentity.isLoggedOut,
    refetchUser = _useIdentity.refetchUser;
  var _useLogout = (0, _useLogout2.useLogout)({
      onLogout: function onLogout() {
        if (navigator.serviceWorker && navigator.serviceWorker.controller) {
          navigator.serviceWorker.controller.postMessage(_utils.ServiceWorkerEvents.LOGOUT);
        }
        logout();
      },
      onError: function onError() {
        return refetchUser();
      }
    }),
    signOut = _useLogout.signOut;
  var _useIdlePing = (0, _useIdlePing2.useIdlePing)(signOut),
    performIdlePing = _useIdlePing.performIdlePing;
  var _useAuthenticated = (0, _useAuthenticated2.useAuthenticated)({
      identity: identity,
      refetchUser: refetchUser
    }),
    user = _useAuthenticated.user,
    isAuthenticated = _useAuthenticated.isAuthenticated;
  var loadingInitial = loadingUser && !identity;
  return /*#__PURE__*/_react.default.createElement(AuthContext.Provider, {
    value: {
      isAuthenticated: isAuthenticated,
      user: user,
      loadingUser: loadingUser,
      logout: signOut,
      performIdlePing: performIdlePing,
      refetchUser: refetchUser,
      wipeIdentity: wipeIdentity
    }
  }, guardRenderingApp({
    loadingInitial: loadingInitial,
    ignorePaths: ignorePaths,
    identity: identity,
    isLoggedOut: isLoggedOut,
    children: children
  }));
};
exports.AuthProvider = AuthProvider;